import { useQuery } from '@tanstack/react-query';
import { METHOD, sendJSONRequest } from '@/state/http-request.helpers.ts';
import { useAuth } from '@clerk/clerk-react';
import type { GetOrganizationRelationEventsResponseDto } from '@/types/dtos/organizations/response/organization-relation.dto.ts';

export const GET_ORGANIZATION_RELATION_EVENTS_QUERY_KEY = 'get-organization-relation-events';

export const useGetOrganizationRelationEventsQuery = (
  organizationId: string | undefined,
  relationId: string | undefined,
  enabled: boolean,
) => {
  const { getToken } = useAuth();

  return useQuery({
    queryKey: [GET_ORGANIZATION_RELATION_EVENTS_QUERY_KEY, organizationId, relationId],
    queryFn: async () => {
      const token = await getToken();
      const url = `${import.meta.env.VITE_API_URL}/organizations/${organizationId}/relations/${relationId}/events`;
      return sendJSONRequest({
        url,
        method: METHOD.GET,
        token: token ?? '',
      }) as Promise<GetOrganizationRelationEventsResponseDto>;
    },
    enabled: !!organizationId && !!relationId && enabled,
  });
};
